import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateDetailEntity } from '../domains/entities/orderTemplate';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';

/**
 * 発注テンプレート詳細を取得するユースケース
 */
export class GetOrderTemplateDetailUseCase {
  /**
   * コンストラクタ
   * @param repository - 発注テンプレート詳細を取得するリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * テンプレート詳細を取得する
   * @param templateId - テンプレートID
   */
  public Execute = async (templateId: string): Promise<INetworkResult<OrderTemplateDetailEntity, IError>> => {
    const result = await this.repository.getDetail(templateId);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toDetailEntity(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
